const actions = {
  SET_STATE: "gauge/SET_STATE",
  RECORD_LIST: "gauge/RECORD_LIST",
  RECORD_TOTAL: "gauge/RECORD_TOTAL",
  CLEAR_DATA: "gauge/CLEAR_DATA",
};

export default actions;
